import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllEmployeeStatuses = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.EmployeeStatus}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getEmployeeStatusById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.EmployeeStatus}?CompanyCode=${companyCode}&code=${code}`
  );
  return data;
};

const insertEmployeeStatus = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.EmployeeStatus, input);
  return data;
};

const updateEmployeeStatus = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.EmployeeStatus, input);
  return data;
};

const deleteEmployeeStatus = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.EmployeeStatus}?CompanyCode=${companyCode}&code=${code}`
  );
  return data;
};

export const useGetEmployeeStatusesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.EmployeeStatus],
    queryFn: () => getAllEmployeeStatuses(input),
     refetchOnWindowFocus: false,
    
  });
};

export const useGetEmployeeStatusByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.EmployeeStatus],
    queryFn: () => getEmployeeStatusById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertEmployeeStatusMutation = () => {
  return useMutation({
    mutationFn: insertEmployeeStatus,
  });
};

export const useUpdateEmployeeStatusMutation = () => {
  return useMutation({
    mutationFn: updateEmployeeStatus,
  });
};

export const useDeleteEmployeeStatusMutation = () => {
  return useMutation({
    mutationFn: deleteEmployeeStatus,
  });
};
